import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles((theme) => ({
    layout: {
      padding:'24px 24px',
      height:'calc(100vh - 146px)',
      overflow:'auto'
    }
  }));
const  ViewPageLayout = (props)=> {
    const classes= useStyles();
    const { children} = props;
    return (
      <>
      <Paper className={classes.layout}>
          {children}
      </Paper>
      </>
    );
}
export default ViewPageLayout;